import type { Page } from '../../types';

const approvalQ4: Page[] = [
  {
    pageType: 'question',
    title: 'Approval',
    name: 'approval-q4',
    hidePageTitle: true,
    disabled: [
      {
        field: 'pending_approval_quarter',
        condition: 'notEquals',
        value: 'Q4',
      },
    ],
    questions: [
      {
        questionType: 'reportPeriod',
        title: 'Period of Report',
        name: 'approval-report-period-q4',
        readOnly: true,
        autoFill: {
          keys: [],
          field: 'report-period',
        },
      },
      {
        questionType: 'textarea',
        title: 'Your assessment of performance',
        hint: 'Taking into account the summary the individual has submitted, along with the 360 feedback received, please provide your assessment of their performance. This will be reviewed by the moderation chair ahead of submission. Please provide a clear, concise summary, which directly relates to the minimum standards and business objectives. In making this end of year assessment, it is important to acknowledge and set aside any personal bias, conscious and unconscious, to ensure an objective appraisal of the person you are reporting on',
        name: 'talent-career-managers-assessment-q4',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'radio',
        title: 'Were the minimum standards met?',
        name: 'talent-career-minimum-standards-met-q4',
        hintOption: 'Select an option',
        options: [
          'Yes',
          {
            option: 'No',
            questions: [
              {
                questionType: 'textarea',
                title: 'Comments',
                name: 'talent-career-minimum-standards-met-comments-q4',
                rules: { required: true },
              },
            ],
          },
        ],
        rules: { required: true },
      },
      {
        questionType: 'select',
        title: 'Indicative End of Year Performance Marking',
        name: 'talent-career-indicative-performance-q4',
        hint: 'Please confirm the indicative performance rating you are putting forward for the individual, noting that this is subject to moderation.  Markings should not be communicated to individuals until formal sign-off has been completed and communicated.',
        hintOption: 'Select an option',
        options: ['Exceeding','High Performing','Achieving','Partially Met'], 
        rules: {
          required: true,
        },
      },
      {
        questionType: 'select',
        title:
          'Is the individual being considered for and currently applying for any development programme?',
        name: 'talent-career-applying-development-programme-q4',
        hintOption: 'Select an option',
        options: [
          {
            option: 'Yes',
            questions: [
              {
                questionType: 'textInput',
                title: 'Please provide details',
                name: 'talent-career-applying-development-programme-details-q4',
                rules: { required: true },
              },
            ],
          },
          'No',
        ],
        rules: { required: true },
      },
      {
        questionType: 'radio',
        title:
          'In your view, is the individual likely to move on from their current role in the next 12 months',
        hint: 'This could include new role in the department, new role across Government or private sector',
        name: 'talent-career-likely-move--12-months-q4',
        hintOption: 'Select an option',
        options: [
          {
            option: 'Yes',
            questions: [
              {
                questionType: 'textarea',
                title: 'Please provide further information',
                name: 'talent-career-likely-move-12-months-detail-q4',
                rules: { required: true },
              },
            ],
          },
          'No',
        ],
        rules: { required: true },
      },
      {
        questionType: 'textarea',
        title:
          'Are there other roles which the individual would be a good fit for, either elsewhere in the DG area or across the Cabinet Office? Please list any roles, along with a short explanation.',
        name: 'talent-career-other-roles-q4',
      },
      {
        questionType: 'textarea',
        title:
          "In your view, what should the individual's development focus be for the next 12 months?",
        hint: 'Please refer to the [Leadership Offer](https://intranet.cabinetoffice.gov.uk/career-development/scs-and-leadership/scs-leadership-offer-and-events/) for details of what is available internally, however this can also include on-the-job learning and external opportunities',
        name: 'talent-career-development-focus-q4',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'select',
        title: 'Indicative End of Year Talent Position',
        name: 'talent-career-manager-9-box-grid-q4',
        hint: 'Please confirm the indicative talent position you are putting forward for the individual',
        detailsHeading: 'Learn more about the 9 Box Grid, including the box defenitions',
        detailsContent:
          'To learn more, please visit: <a href="https://intranet.cabinetoffice.gov.uk/information-for-employees/pay-and-reward/scs-pay-and-reward/scs-career-development-conversations/" target="_blank" rel="noopener noreferrer">intranet guidance</a>.',
        hintOption: 'Select an option',
        options: [
          '1 Star',
          '2 Excellent',
          '3 High Potential',
          '4 Strong',
          '5 Good',
          '6 Expert',
          '7 Early Promise',
          '8 Effective',
          '9 Inconsistent',
        ],
        rules: {
          required: true,
        },
      },
      {
        questionType: 'checkbox',
        title:
          'In making this end of year assessment, it is important to acknowledge and set aside any personal bias, conscious and unconscious, to ensure an objective appraisal of the person you are reporting on.',
        name: 'talent-career-manager-decleration-q4',
        options: ['I confirm acknowledgement of this statement'],
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default approvalQ4;
